'use strict';

var $ = require('jquery');
var MarkerClusterer = require('marker-clusterer-plus');
var MarkerIcon = require('./MarkerIcon.js');
var ViewportTracker = require('../lib/ViewportTracker.js');
var Debouncer = require('../lib/Debouncer.js');
var GoogleMapStyle = require('./GoogleMapStyle.js');

function latLonToString(latlon) {
	return latlon.lat()+","+latlon.lng();
}

module.exports = function(){
	if (typeof google === 'undefined') {
		console.warn('google object not defined. Returning dummy init method for PropertyMap.');
		return { init : function(){} };
	}

	var locationChanged = false;
	var $mapDiv = $('#property-map');
	if ($mapDiv.length == 0){
		return;
	}

	var $win = $(window);

	// Map
	var map;
	var defaultMapCenter = new google.maps.LatLng(44.972865,-93.16875);

	function removeStateRestriction() {
		locationChanged = true;
	}

	// Markers
	var markerGroup = [];
	var markerClusterer = null;
	var markerClustererStyles = {
		gridSize : 30,
		styles : [{
			url : 'assets/images/design/vector-group.svg',
			height : 30,
			width : 30,
			anchor : [0, 0],
			textColor : '#ffffff',
			textSize : 10
		}]
	};

	// Locations
	var container = $('#property-listing');
	var scrollContainer = $('#property-results-list');
	var locationImages = null;
	var locations = [];
	var visibleLocations = [];
	var latLngBounds = new google.maps.LatLngBounds();
	var infoWindow = new google.maps.InfoWindow({disableAutoPan: true});

	// Radius
	var radiusCircle = null;
	var radiusCircleOptions = {
		strokeColor : '#c44c41',
		strokeOpacity : 0.8,
		strokeWeight : 2,
		fillColor : '#c44c41',
		fillOpacity : 0.02,
		map : null,
		center : null,
		radius : null
	};

	// Search
	var $form = $('#property-search');
	var currentSearch = {};
	var fullPropertiesList;

	function getFullPropertiesList() {
		return fullPropertiesList;
	}
	function setFullPropertiesList(fullList) {
		fullPropertiesList = fullList;
	}

	function getCurrentSearch() {
		$form.find('select, input[type="checkbox"]').each(function() {
			var $this = $(this);
			var id = $this.attr('name');
			if (id === undefined)
				return;

			var value;
			if ($this.attr('type') === 'checkbox') {
				value = $this.prop('checked');
			} else {
				value = $this.val();
			}

			currentSearch[id] = value;
		});
		var loc = $form.find('#location').val();
		if (typeof loc !== 'undefined') {
			currentSearch.location = loc;
		}

		return currentSearch;
	}
	function setCurrentSearch(criteria) {
		currentSearch = criteria;

		updateFiltersWithCurrentSearch(criteria);
	}

	function updateFiltersWithCurrentSearch( currentSearch ) {
		$form.find("input:not([type='submit']):not([name='javax.faces.ViewState']), select").each(function() {
			var $this = $(this);
			var name = $this.attr('name');

			if (name in currentSearch) {
				if ($this.prop("type") == "checkbox") {
					$this.prop("checked", currentSearch[name]);
				} else {
					$this.val( currentSearch[name] );
				}
			}
		});
		$form.find('input[name="sortByHook"]').val(currentSearch['sortBy']);
		$('select[name="sortBy"]').val(currentSearch['sortBy']);
	}

	var urlHash = {
		get : function() {
			var hash = document.location.hash;
			var id = null;
			if (hash.length > 0) {
				// Removes the '#'
				id = hash.substring(1);
			}
			return id;
		},
		set : function(id) {
			if (typeof id === "undefined") {
				document.location.hash = "";
			} else {
				document.location.hash = encodeURI(id);
			}
		}
	}


	function round(value, decimals) {
		return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
	}
	function convertMilesToMeters(miles) {
		return 1609.34 * miles;
	}

	/*
	 * Ajax message area for updating the user
	 */
	var messageArea = (function(){
		var messageParent = $('#property-results-list');
		var messageElem = $('<div class="property-results--message">Message Area</div>').appendTo(messageParent);

		return {
			update: function(msg) {
				messageParent.toggleClass('hasMessage', true);
				messageElem.html(msg);
			},
			hide: function() {
				messageParent.toggleClass('hasMessage', false);
				messageElem.html('');
			}
		}
	})();

	/*
	 * Basic Map setup, self-invoking because the map needs to be setup immediately and is never called again.
	 */
	map = (function() {
		var currentSearch = getCurrentSearch();
		var mapCenter;
		if (currentSearch != null && currentSearch.radiusFrom != null) {
			mapCenter = new google.maps.LatLng(currentSearch.radiusFrom[0], currentSearch.radiusFrom[1]);
		} else {
			mapCenter = defaultMapCenter;
		}

		var mapOptions = {
			center: mapCenter,
			zoom: 2,
			minZoom: 3,
			maxZoom: 15,
			mapTypeControl: false,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			panControl: false,
			panControlOptions: {
				style: google.maps.ZoomControlStyle.SMALL,
				position: google.maps.ControlPosition.LEFT_TOP
			},
			scrollwheel: true,
			zoomControlOptions: {
				style: google.maps.ZoomControlStyle.SMALL,
				position: google.maps.ControlPosition.LEFT_BOTTOM
			},
			streetViewControl: false,

			// Must use two fingers to pan
			gestureHandling: 'cooperative',

			styles: GoogleMapStyle
		};
		
		var mapElement = $mapDiv.get(0);
		var map = new google.maps.Map(mapElement, mapOptions);

		// Change map center on resize
		var resizeTimer;
		var originalCenter;
		var getNewCenter = true;

		google.maps.event.addDomListener(window, "resize", function(){
			if ( getNewCenter ) {
				originalCenter = map.getCenter();
				getNewCenter = false;
			}
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(function(){
				map.setCenter(originalCenter);
				getNewCenter = true;
			}, 250); // debounce
		});
		// CSS removes loading graphic which causes browser load
		$('#property-results-map').addClass('loaded');

		return map;
	})();

	/*
	 * Draws a circle on the map based on the search radius from currentSearch
	 */
	function drawRadiusCircle(currentSearch) {
		var radius = currentSearch.radius;

		if (radiusCircle){
			// Remove any previous circle
			radiusCircle.setMap(null);
		}

		if (
			typeof currentSearch.northEastBounds === 'undefined' ||
			typeof currentSearch.southWestBounds === 'undefined'
		) {
			return;
		}

		if (currentSearch != null && currentSearch.radiusFrom != null) {
			// Draw new radius
			var ops = $.extend(radiusCircleOptions, {
				radius: round(convertMilesToMeters(radius), 4),
				center: new google.maps.LatLng(currentSearch.radiusFrom[0], currentSearch.radiusFrom[1]),
				map: map
			})
			radiusCircle = new google.maps.Circle(ops);
		}
	}

	function Location(item){
		this.id = item.id;
		this.item = item;
		this.elem = null;
		this.dist = round(item.dist, 2);
		this.bedrooms = item.numberOfBedrooms;
		this.bathrooms = item.numberOfBathrooms;
		this.seniorLiving = item.seniorLiving;
		this.section8 = item.section8;
		this.affordable = item.affordable;
		this.luxury = item.luxury;
		this.airConditioning = item.airConditioning;
		this.smokeFree = item.smokeFree;
		this.patioBalcony = item.patioBalcony;
		this.petFriendly = item.petFriendly;
		this.washerDryer = item.washerDryer;
		this.garageCoveredParking = item.garageCoveredParking;
		this.visible = false;
	}
	Location.prototype.createMarkup = function(container) {
		if (this.elem) {
			this.elem.off('mouseenter mouseleave');
			if (this.marker) {
				this.marker.setIcon(MarkerIcon.icon.default);
			}
		}
		var item = this.item;
		var parts = '';

		var image;
		var imageClass = 'media__image';
		if (typeof item.photo === 'undefined') {
			image = '';
			imageClass += ' placeholder';
		} else {
			image = '<span>\
				<img src="assets/images/design/alpha.gif" data-original="' + item.photo + '" alt="image of '+item.name+' property" width="100%" height="100%" >\
			</span>';
		}

		parts += '<div class="listing property';
		if (item.seniorLiving > 0) {
			parts += ' seniorLiving';
			parts += ' sr' + item.seniorLiving;
		}
		if (item.section8) {
			parts += ' section8';
		}
		if (item.affordable) {
			parts += ' affordable';
		}
		if (item.luxury) {
			parts += ' luxury';
		}
		parts += '" data-featured="' + (item.featured ? 'true' : 'false') + '">\
			<div class="inner media">\
				<a class="' + imageClass + '" href="'+item.href+'" target="_blank" rel="noopener noreferrer">\ ' + image + '</a>\
				<div class="media__content">\
					<h4 class="property__title">\
						<a href="'+item.href+'" target="_blank" rel="noopener noreferrer">'+item.name+'</a>\
					</h4>';

		if (item.showSubtitle) {
			parts += '<div class="property__subtitle">';
			if (item.numberOfBedrooms > 0){
				parts += '<span>'+item.numberOfBedrooms+' Beds</span>';
			}
			if (item.numberOfBathrooms > 0) {
				if (item.numberOfBedrooms > 0){
					parts += ' <span class="separator">•</span> ';
				}
				parts += '<span>'+item.numberOfBathrooms+' Baths</span>';
			}
			if (item.dist){
				if (item.numberOfBedrooms > 0 || item.numberOfBathrooms){
					parts += ' <span class="separator">•</span> ';
				}
				parts += '<span>'+this.dist+' mile</span>';
			}
			parts += '</div>';
		}

		var $div = $('<div/>');
		parts += '		<div>\
							<div class="vcard" itemscope="itemscope" itemtype="http://schema.org/ApartmentComplex" data-lat="'+item.latitude+'" data-lon="'+item.longitude+'">\
								<div class="adr" itemprop="address" itemscope="itemscope" itemtype="http://schema.org/PostalAddress">\
									<div itemprop="streetAddress">\
										<span class="street-address">'+$div.text(item.streetAddress).html()+'<span>, </span></span>\
									</div>\
									<div>\
										<span itemprop="addressLocality" class="locality">'+$div.text(item.city).html()+'</span>, \
										<span itemprop="addressRegion" class="region">'+$div.text(item.state).html()+'</span> \
										<span itemprop="postalCode" class="postal-code">'+$div.text(item.zipCode).html()+'</span>\
									</div>\
								</div>';
				if (item.phone) {
					parts += '<div class="phone">\
									<a href="tel:' + $div.text(item.phone).html() + '">' + $div.text(item.phone).html() + '</a>\
								</div>';
				}
				if (item.email) {
					parts += '<div class="email">\
									<a href="mailto:' + $div.text(item.email).html() + '">' + $div.text(item.email).html() + '</a>\
								</div>';
				}
		parts += '				</div>\
							<div class="property__link"><a href="' + item.href + '" target="_blank" rel="noopener noreferrer">View Property</a></div>';
		parts += '		</div>\
					</div>\
				</div>\
			</div>';
		this.elem = $(parts).appendTo( container );
		var loc = this;
		var getMarker = function() {
			return loc.getMarker();
		};
		this.elem.on({
			mouseenter : function(event) {
				if (getMarker()) {
					getMarker().setIcon(MarkerIcon.icon.active);
				}
			},
			mouseleave : function(event) {
				if (getMarker()) {
					getMarker().setIcon(MarkerIcon.icon.default);
				}
			}
		});
	}
	Location.prototype.isVisible = function() {
		return this.visible;
	}
	Location.prototype.toggleVisible = function(value, isOdd) {
		this.marker.setVisible( value );

		this.elem.toggleClass('onscreen', value);
		this.visible = value;

		this.elem.toggleClass('property--odd', isOdd);

		if (markerClusterer){
			if (value){
				markerClusterer.addMarker(this.marker);
			} else {
				markerClusterer.removeMarker(this.marker);
			}
		}
	}
	Location.prototype.createMarker = function(markers, map) {
		var that = this;
		var item = that.item;
		var	latlng = new google.maps.LatLng( item.latitude , item.longitude );
		var marker = new google.maps.Marker({
			content: item.name,
			icon : MarkerIcon.icon.default,
			map : map,
			optimized : false,
			position : latlng,
			url : item.href,
			zIndex : 1
		});

		var closureElem = this.elem;
		marker.addListener('mouseover', function() {
			marker.setIcon(MarkerIcon.icon.active);
			closureElem.addClass('hovered');
			//closureElem[0].scrollIntoView(false); //There isn't a particularly good cross-browser solution to this problem as of right now
			infoWindow.setContent(marker.content);
			infoWindow.open(map, marker);
		});
		marker.addListener('mouseout', function() {
			infoWindow.close();
			closureElem.removeClass('hovered');
			marker.setIcon(MarkerIcon.icon.default);
		});
		marker.addListener('click', function() {
			closureElem.find('.media__image')[0].click();
		});
		markers.push(marker);
		markerGroup.push([that.elem, marker]);

		this.marker = marker;
	}
	Location.prototype.getMarker = function() {
		return this.marker;
	}

	/*
	 * Uses propertyList to create markers and create locations
	 * */
	function createListingsFromJSON(propertyList, extendBounds) {
		if (markerClusterer) {
			markerClusterer.clearMarkers();
		}

		locations = [];
		container.toggleClass('loaded', false).html('');

		var markers = [];
		for (var i = 0, l = propertyList.length; i < l; ++i) {
			locations[i] = new Location(propertyList[i]);
			locations[i].createMarkup(container);
			locations[i].createMarker(markers, map);

			if (extendBounds){
				latLngBounds.extend( locations[i].getMarker().getPosition() );
			}
		}

		markerClusterer = new MarkerClusterer(map, markers, markerClustererStyles);

		if (extendBounds){
			map.fitBounds( latLngBounds );
		}

		container.toggleClass('loaded', true);
	}

	function getParameterByName(name, url) {
	    if (!url) {
	      url = window.location.href;
	    }
	    name = name.replace(/[\[\]]/g, "\\$&");
	    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
	        results = regex.exec(url);
	    if (!results) return null;
	    if (!results[2]) return '';
	    return decodeURIComponent(results[2].replace(/\+/g, " "));
	}

	/*
	 * checks if the location marker is within the map bounds and hides it from the list accordingly
	 * */
	function filterLocations(currentSearch) {
		var currentSearch = currentSearch || getCurrentSearch();
		var isMobile = ViewportTracker.getState() == 'mobile';
		var currentStateSearch = locationChanged ? null : getParameterByName('state');

		var updateNeeded = false;
		var newVisibleLocations = {};
		var bounds = map.getBounds();

		drawRadiusCircle(currentSearch);
		for (var i = 0, l = locations.length; i < l; ++i) {
			var location = locations[i];

			var visible = (!currentStateSearch || location.item.state == currentStateSearch) &&
						(isMobile || bounds == null || bounds.contains(location.marker.getPosition())) &&
						(!currentSearch.seniorLiving || location['seniorLiving']) &&
						(!currentSearch.section8 || location['section8']) &&
						(!currentSearch.affordable || location['affordable']) &&
						(!currentSearch.luxury || location['luxury']) &&
						(!currentSearch.airConditioning || location['airConditioning']) &&
						(!currentSearch.smokeFree || location['smokeFree']) &&
						(!currentSearch.patioBalcony || location['patioBalcony']) &&
						(!currentSearch.petFriendly || location['petFriendly']) &&
						(!currentSearch.washerDryer || location['washerDryer']) &&
						(!currentSearch.garageCoveredParking || location['garageCoveredParking']) &&
						(!currentSearch.bedrooms || location['bedrooms'] >= currentSearch.bedrooms) &&
						(!currentSearch.bathrooms || location['bathrooms'] >= currentSearch.bathrooms);

			if (visible) {
				newVisibleLocations[location.id] = true;
			}
			if (visible !== location.visible) {
				// Stating changing from what was before
				updateNeeded = true;
			}
		}

		if (updateNeeded) {
			// Locations to be visible different than before.

			if (markerClusterer) {
				markerClusterer.clearMarkers();
			}

			visibleLocations = [];
			var visible;
			var visibleIndex = -1;
			for (var i = 0, l = locations.length; i < l; ++i) {
				var location = locations[i];

				if (location.id in newVisibleLocations) {
					visibleLocations.push(location.id);
					visible = true;
					visibleIndex++;
				} else {
					visible = false;
				}
				location.toggleVisible(visible, visible === true ? visibleIndex % 2 !== 0 : false);
			}
		}

		if (visibleLocations.length === 0) {
			messageArea.update( 'No Properties Matched' );
		} else {
			// Notify lazy load code to load images.
			scrollContainer.trigger('locations-filtered');

			messageArea.hide();
		}

		// Broadcast events about property results being updated
		$(document).trigger('propertyResultsUpdated');
	}


	/*
	 * Used to allow for client side interactions without requiring round trips to the server
	 * */
	(function(){
		function submittingForm(updateBounds) {
			removeStateRestriction();
			saveCriteriaToServer(true, true, updateBounds);
		}

		$form.on('submit', function(e) {
			e.preventDefault();
			submittingForm(true);
		});
		$form.find('input[data-updateBounds="false"]').on('click', function(e) {
			e.preventDefault();
			// Make bounds of map not update when search takes place
			submittingForm(false);
		});

		$('#sortBy').on('change', function(e) {
			$('input[name="sortByHook"]').val($(this).val());
			saveCriteriaToServer(true, true);
		});

		$form.find('#location').on('change', function() {
			removeStateRestriction();
			$form.addClass('has-changed');
		});

		$form.find('.propertySearch--clear').on('click', function() {
			$form.find('input[type="checkbox"]').each(function() {
				var $element = $(this);
				$element.prop('checked', false);
			});

			filterLocations();
			saveCriteriaToServer(false);
		});

		$form.find('.autoUpdateResults').on('change', function() {
			filterLocations();
			saveCriteriaToServer(false);
		});
		$form.find('select[name="radius"]').on('change', function(e) {
			removeStateRestriction();
			//$form.submit();
		});
	})();

	function updateMapBoundsBasedOnResults() {
		var currentSearch = getCurrentSearch();

		if (typeof currentSearch.northEastBounds !== "undefined" && currentSearch.northEastBounds && currentSearch.southWestBounds) {
			// Center map / zoom based on bounds
			var ne = new google.maps.LatLng(currentSearch.northEastBounds[0], currentSearch.northEastBounds[1]);
			var sw = new google.maps.LatLng(currentSearch.southWestBounds[0], currentSearch.southWestBounds[1]);

			myFitBounds(map, new google.maps.LatLngBounds(sw, ne));

			// fitBounds doesn't set to exact level needed but just ensures the
			// bounds fits in the map. Here I attempt to zoom in a little.
			var zoom = map.getZoom();
			var bounds = map.getBounds();
			if (bounds != null) {
				while (zoom <= 100) {
					if (bounds.contains(sw) && bounds.contains(ne)) {
						zoom++;
						map.setZoom(zoom);
						bounds = map.getBounds();
					} else {
						map.setZoom(zoom - 1);
						break;
					}
				}
			}

		}
	}

	function myFitBounds(myMap, bounds) {
		myMap.fitBounds(bounds); // calling fitBounds() here to center the map for the bounds

		var overlayHelper = new google.maps.OverlayView();
		overlayHelper.draw = function () {
			if (!this.ready) {
				var extraZoom = getExtraZoom(this.getProjection(), bounds, myMap.getBounds());
				if (extraZoom > 0) {
					myMap.setZoom(myMap.getZoom() + extraZoom);
				}
				this.ready = true;
				google.maps.event.trigger(this, 'ready');
			}
		};
		overlayHelper.setMap(myMap);
	}

	function getExtraZoom(projection, expectedBounds, actualBounds) {
		// in: LatLngBounds bounds -> out: height and width as a Point
		function getSizeInPixels(bounds) {
			var sw = projection.fromLatLngToContainerPixel(bounds.getSouthWest());
			var ne = projection.fromLatLngToContainerPixel(bounds.getNorthEast());
			return new google.maps.Point(Math.abs(sw.y - ne.y), Math.abs(sw.x - ne.x));
		}

		var expectedSize = getSizeInPixels(expectedBounds);
		var actualSize = getSizeInPixels(actualBounds);

		if (Math.floor(expectedSize.x) == 0 || Math.floor(expectedSize.y) == 0) {
			return 0;
		}

		var qx = actualSize.x / expectedSize.x;
		var qy = actualSize.y / expectedSize.y;
		var min = Math.min(qx, qy);

		if (min < 1) {
			return 0;
		}

		return Math.floor(Math.log(min) / Math.LN2 /* = log2(min) */);
	}

	function setupCurrentResults(updateBounds) {
		if (updateBounds === undefined)
			updateBounds = true;

		var propertyList = getFullPropertiesList();
		var currentSearch = getCurrentSearch();
		var boundMapToMarkersCreated = typeof currentSearch.northEastBounds === 'undefined';

		if (updateBounds) {
			updateMapBoundsBasedOnResults();
		}

		createListingsFromJSON(propertyList, boundMapToMarkersCreated);

		// this also gets called once the map.idle event is triggered
		filterLocations(currentSearch);

		if (currentSearch.id != null) {
			urlHash.set( currentSearch.id );
		}
	}

	var dataSavedLastTime = null;
	function stringifyPropsInOrder(obj) {
		var keys = Object.keys(obj).sort();
		var output = [], prop;
		for (var i = 0; i < keys.length; i++) {
			prop = keys[i];
			output.push(prop);
			output.push(obj[prop]);
		}
		return JSON.stringify(output);
	}

	var saveCriteriaToServer = function(createNew, reloadResults, updateBounds) {
		var currentSearch = getCurrentSearch();

		if (!createNew && typeof currentSearch.id === "undefined") {
			return;
		}

		var type = createNew ? 'create' : 'update';

		var bounds = map.getBounds();
		var data = {};
		for (var prop in currentSearch) {
		    if (currentSearch.hasOwnProperty(prop)) {
		        data[prop] = currentSearch[prop];
		    }
		}

		data.northEastBounds = latLonToString(bounds.getNorthEast());
		data.southWestBounds = latLonToString(bounds.getSouthWest());

		data.propertyIds = "";
		data.sortBy = $('#sortBy').val();

		var newDataStringify = stringifyPropsInOrder(data);

		if (!createNew && dataSavedLastTime !== null) {
			if (newDataStringify === dataSavedLastTime) {
				// Data hasn't save since last save so don't do anything
				return;
			}
		}

		// Store data last time saved so we don't end up in some type of never ending saving loop
		dataSavedLastTime = newDataStringify;

		return communicateWithServer(type, data, reloadResults, undefined, updateBounds);
	}

	var loadCriteriaFromServer = function(id, alwaysHandler) {
		var data = {
			id: id
		};
		return communicateWithServer("get", data, true, alwaysHandler, undefined);
	}

	/*
	 * Saves or updates a search criteria on the server.
	 * */
	var communicateWithServer = function(type, data, reloadResults, alwaysHandler, updateBounds) {
		data = data || {};

		if (typeof reloadResults !== "undefined" && reloadResults) {
			data.reloadResults = reloadResults;
		}

		var url = document.getElementsByTagName("BASE")[0].href;
		if (url.endsWith('/')) {
			url += "property-search-data/" + type;
		} else {
			url += "/property-search-data/" + type;
		}

		messageArea.update('<i class="icon icon-loading"></i> Searching for Properties ...');

		// Send the request
		$.ajax({
			url : url,
			data : data
		}).done(function(data) {
			if (reloadResults) {
				messageArea.update('<i class="icon icon-loading"></i> Reloading Results.');

				setCurrentSearch(data.criteria);
				setFullPropertiesList(data.results);

				setupCurrentResults(updateBounds);

				// Ensure no error message displayed
				$(".property-search-messages").html("");
				$("#locationFieldArea").removeClass("containsError");

				if (
						typeof data.criteria !== "undefined"
						&& typeof data.criteria.locationGeocodeStatus !== "undefined"
						&& data.criteria.locationGeocodeStatus == "ERROR_BAD_LOCATION"
					) {
					// Unable to find specified location
					$('<div class="error"/>')
						.appendTo(".property-search-messages")
						.text("We were unable to find the location specified. Please check the value and try again: " + data.criteria.location);
					$("#locationFieldArea").addClass("containsError");
				}
			}
			if ( typeof data.criteria !== "undefined" ) {
				setCurrentSearch(data.criteria); // Ensure have most recent copy
				urlHash.set(data.criteria.id);
			}
		}).fail(function(jqXHR, textStatus) {
			messageArea.update('There was an error.  Please try again.');
		}).always(function() {
			messageArea.update('One Moment &hellip;');
			messageArea.hide();
			if (visibleLocations.length === 0) {
				messageArea.update( 'No Properties Matched' );
			}

			$form.removeClass('has-changed');

			if (alwaysHandler !== undefined) {
				alwaysHandler();
			}
			if (triggerGA !== undefined) {
				triggerGA();
			}
		});
	}

	/*
	 * Event Handlers
	 * */
	function eventHandlerHashChange(){
		var id = urlHash.get();
		var currentSearch = getCurrentSearch();
		if (id !== currentSearch.id) {
			loadCriteriaFromServer(id);
		}
	}

	var lastBounds = null;
	function eventHandlerMapIdle() {
		// We only care when bounds change
		var lastBoundsWas = lastBounds;
		var bounds = map.getBounds();
		lastBounds = latLonToString(bounds.getNorthEast()) + ":" + latLonToString(bounds.getSouthWest());

		if (lastBoundsWas !== lastBounds) {

			// TODO: i don't think this should be here..
			//removeStateRestriction();

			filterLocations();

			saveCriteriaToServer(false);
		}
	}

	return {
		init: function(currentSearch, fullPropertiesList){
			setCurrentSearch(currentSearch);
			setFullPropertiesList(fullPropertiesList);

			// Setup lazy load of images
			var lazyLoadImagesDebouncer = new Debouncer(function() {
				var pageTop = $win.scrollTop();
		        var pageBottom = pageTop + $win.height();

				var $locationImages = container.find('img');

				for (var i=0; i < $locationImages.length; i++) {
					var $img = $($locationImages.get(i));
	            	var original = $img.attr('data-original');
	            	if (original === undefined) {
	            		continue;
	            	}

			        var elementTop = $img.offset().top;

		            if (
		            		elementTop <= pageBottom
		            		&& (elementTop + $img.height()) >= pageTop
		            	) {
		            	$img.attr('src', original);
		            	$img.removeAttr('data-original');
			        } else if (elementTop > pageBottom) {
			        	// Off the screen. No reason to continue
			        	break;
			        }
				}
			}, true, 500);
			scrollContainer.on('scroll locations-filtered', lazyLoadImagesDebouncer.run);

			function setupSaveOnMapChange() {
				// Setup handler so we are notified when the map moves

				google.maps.event.addListenerOnce(map, 'idle', function() {
					// Once map is ready filter results. We wait until map is ready
					// because filtering uses the maps bounds
					filterLocations();

					// Wait until first idle to register our listener so it doesn't trigger over and over
					// (Uses 'idle' instead of 'bounds_changed' because 'idle' is "This event is fired when the map becomes idle after panning or zooming.")
					map.addListener('idle', eventHandlerMapIdle);
				});
			}

			var id = urlHash.get();
			if ( id != null ) {
				loadCriteriaFromServer(id, setupSaveOnMapChange);
			} else {
				setupSaveOnMapChange();

				setupCurrentResults();
			}

			$win.on('hashchange', eventHandlerHashChange);
		}
	};
};
